import React, { useState, useEffect } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import apiService from '../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import MenuVerDiagnosticos from './MenuVerDiagnosticos';
import ButtonsMenu from '../../Utils/ButtonsMenu';
import { useAuth } from './../../../Auth/AuthContext';
import { BotonVerAtencionesPersona } from '../../Utils/BotonVerAtencionesPersona';
export default function DatosPersonalesHogar(){
    const {token} = useAuth();
    const navigate = useNavigate();
    const [Cargando, setCargando] = useState(false);
    const [datoscabeza, setDatoscabeza] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10); 
    const [swalProps, setSwalProps] = useState();
    useEffect(() => {
        fetchData(currentPage, perPage);
    }, [currentPage, perPage]);
    const fetchData = async (page, rowsPerPage) => {
        const url = `/caracterizacion/diagnosticos/listardatoshogar?page=${page}&limit=${rowsPerPage}`;
        try {
            setCargando(true);
            const response = await apiService.get(url,token);
            const result = await response.data;
            setDatoscabeza(result.data);
            setTotalRows(result.meta.total);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
        
        
    };
    function verAtencionPersona (row){
        return <BotonVerAtencionesPersona verAtencionesPersona={verAtencionesPersona} id={row.per_idpersona} row={row} />
    }
    const columns = [
        {
            name: 'Acciones',
            cell: row => verAtencionPersona(row),
            ignoreRowClick: true,
            width: '3%'
        },
        { name: 'Fecha de Creación', selector: row => row.per_fechacreacionsistema.split("T")[0], sortable: true, width:'5%' },
        { name: 'Fecha última caracterización', selector: row => row.cab_fechamodificacion.split("T")[0], sortable: true, width: '6%'},
        { name: 'Código SIPOD', selector: row => row.cab_nodeclaracion, sortable: true, width: '4%' },
        { name: 'Fecha de Valoración', selector: row => row.per_fecharegistrosipod.split("T")[0], sortable: true, width: '5%' },
        { name: 'Identificación Cabeza', selector: row => row.cab_idcabezafamilia, sortable: true, width: '5%' },
        { name: 'Tipo Identificación', selector: row => row.tip_tipoidentificacion, sortable: true, width: '5%' },
        { name: 'Identificación', selector: row => row.per_idpersona, sortable: true, width: '5%' },
        { name: 'Primer Nombre', selector: row => row.per_nombre1, sortable: true, width: '4%' },
        { name: 'Segundo Nombre', selector: row => row.per_nombre2, sortable: true, width: '4%' },
        { name: 'Primer Apellido', selector: row => row.per_apellido1, sortable: true, width: '4%' },
        { name: 'Segundo Apellido', selector: row => row.per_apellido2, sortable: true, width: '5%' },
        { name: 'Parentesco', selector: row => row.par_parentesco, sortable: true, width: '5%' },
        { name: 'Sexo', selector: row => row.per_sexo, sortable: true, width: '3%' },
        { name: 'Año Naci', selector: row => row.per_anonaci, sortable: true, width: '3%' },
        { name: 'Mes Naci', selector: row => row.per_mesnaci, sortable: true, width: '3%' },
        { name: 'Día Naci', selector: row => row.per_dianaci, sortable: true, width: '3%' },
        { name: 'Edad', selector: row => row.per_edad, sortable: true, width: '3%' },
        { name: 'Minoria', selector: row => row.min_minoria, sortable: true, width: '5%' },
        { name: 'Discapacidad', selector: row => row.dis_discapacidad, sortable: true, width: '5%' },
        { name: 'Gestante', selector: row => row.per_gestante, sortable: true, width: '5%' },
        { name: 'Meses Gestación', selector: row => row.per_mesesgestacion, sortable: true, width: '5%' },
        { name: 'Fecha Gestancia', selector: row => row.per_fechagestancia, sortable: true, width: '5%' },
        { name: 'Lactante', selector: row => row.per_lactante, sortable: true, width: '5%' },
        { name: 'Fecha Lactancia', selector: row => row.per_fechalactancia, sortable: true, width: '5%' },
        { name: 'Menor sin Acudiente', selector: row => row.per_msacudiente, sortable: true, width: '5%' },
        { name: 'Estado SIPOD', selector: row => row.est_estado, sortable: true, width: '5%' },
        { name: 'Oficio Actual', selector: row => row.ofi_oficio, sortable: true, width: '5%' },
        { name: 'Actividad Actual', selector: row => row.act_actividad, sortable: true, width: '5%' },
        { name: 'Creado por', selector: row => row.usr_nombre, sortable: true, width: '5%' }
    ];
    function verAtencionesPersona (row){
        navigate(`/consulta/consultaatenciones/${row.per_idpersona}`);
    };
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
        fetchData(page, newPerPage);
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, perPage);
      };
    async function exportarCSV() {
        setCargando(true);
        const url = `/caracterizacion/diagnosticos/listardatoshogar?page=0&limit=0&csv=true`;

        try {
            const response = await apiService.get(url, token, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'datos_hogar.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Diagnostico datos personales (hogar)</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to="/consultas/verdiagnosticos" >Diagnosticos</NavLink></li>
                        <li className="breadcrumb-item active"> Datos hogar</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuVerDiagnosticos />
                    <div className="row">
                        <div className="col-md-12">
                            <ButtonsMenu data={datoscabeza} titulo={'Informe Datos Hogar'} exportarCSV={exportarCSV} />
                            <div className="card-body table-responsive p-0">
                                <DataTable
                                    title="Datos cabeza"
                                    columns={columns}
                                    data={datoscabeza}
                                    progressPending={Cargando}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    paginationPerPage={perPage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>

            


        </div>
    );
}